import { connect } from 'react-redux';

import { offerIdAsNumberSelector } from 'shared/store/custom';
import { IApplicationState } from 'shared/types/redux';

import { FlexOfficeList as FlexOfficeListComponent } from './FlexOfficeList';
import { coworkingSortedOffersSelector } from './internal/selectors/coworkingSortedOffersSelector';

export const mapState = (state: IApplicationState) => ({
  offers: coworkingSortedOffersSelector(state),
  selectedOfferId: offerIdAsNumberSelector(state),
});

export const FlexOfficeList = connect(mapState)(FlexOfficeListComponent);
